import React from 'react';

import { FavoriteCountType } from '../../types';
import useFavoriteCount from './useFavoriteCount';

interface Props {
    type: FavoriteCountType;
}

const FavoriteCount: React.FC<Props> = ({ type }) => {
    const { count } = useFavoriteCount({ type });

    if (count === null || (type === 'all' && !count) || count < 0) return null;

    return <div className="__app-FavoriteCount-container">{count}</div>;
};

export default FavoriteCount;
